import * as tslib_1 from "tslib";
import { DaliService, } from '@dali/tagger-ng8';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { TagIdentifier } from '../../models/dali-tags.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { ParametersService } from '../parameters/parameters.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { PAGEVIEW } from '../../constants/dali-fa-tc.constants';
import { EVENT } from '../../constants/dali.constants';
import { CHANNEL } from '../../constants/channel.constants';
import * as i0 from "@angular/core";
import * as i1 from "@dali/tagger-ng8";
import * as i2 from "../abre-cuentas/abre-cuentas.service";
import * as i3 from "../parameters/parameters.service";
import * as i4 from "../communicator/channel-communicator/channel-communicator.service";
import * as i5 from "../external/biocatch/biocatch.service";
import * as i6 from "../firmly-approved/firmly-approved.service";
// import { NavigationService } from '../navigation/navigation.service';
/**
 * Obtener el valor de una dependencia, en este caso, ésta clase es visible para toda la app
 *
 * *Obtain the valua of a dependency, in this case, this class is visible for the entire app*
 */
var TaggingService = /** @class */ (function () {
    /**
     * Constructor del componente
     *
     * *Constructor of the component.*
     *
     * @param {AbreCuentasService}         daliService                 Injectable dali service.
     * @param {AbreCuentasService}         abreCuentasService          Injectable abreCuentasService service.
     * @param {NavigationService}          navigationService           Injectable navigationService service.
     * @param {ChannelCommunicatorService} channelCommunicatorService  Injectable channelCommunicatorService service.
     */
    function TaggingService(daliService, abreCuentasService, parameterService, channelCommunicatorService, bioCatchService, firmlyApprovedService) {
        var _this = this;
        this.daliService = daliService;
        this.abreCuentasService = abreCuentasService;
        this.parameterService = parameterService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.bioCatchService = bioCatchService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.environment = '';
        this.GTM_CODE = '';
        /**
         * Nombre de la ruta del tag de analítica
         *
         * *Tags name path of analytics*
         *
         * @access              private
         * @type                { TagPathProduct }
         */
        // private tagsNamePath: TagPathProduct;
        this.productsType = {
            ORD: 'LD',
            TCR: 'TC',
            CRP: 'CR',
        };
        /**
         * Método get para la variable privada tagsIdentifier
         * solo para las pruebas unitarias
         *
         * *Get method for private tagsIdentifier variable*
         * *Just for unit tests*
         */
        this.getTagIdentifier = function () { return _this.tagsIdentifiers; };
        /**
         * Método set para la variable privada tagsIdentifier,
         * solo para las pruebas unitarias
         *
         * *Set method for private tagsIdentifier variable*
         * *Just for unit tests*
         */
        this.setTagIdentifier = function (tagIdentifier) {
            return (_this.tagsIdentifiers = tagIdentifier);
        };
        this.getProductFlow = function () {
            return _this.productsType[_this.abreCuentasService.getProductsSelects()[0].product];
        };
        this.isFirmlyAprovedMono = function () {
            return _this.firmlyApprovedService.isFirmlyApproved() &&
                _this.abreCuentasService.getProductsSelects().length === 1;
        };
    }
    /**
     * Función de inicialización de la librería Dali
     *
     * *Initialization function for Dali library*
     *
     * @returns {Promise}
     */
    TaggingService.prototype.initAnalytics = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var abreCuentasConfigs, daliEnv, IS_RELEASE_ENV, analyticsJsonURL;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                abreCuentasConfigs = this.abreCuentasService.getAbreCuentasConfigs();
                daliEnv = this.parameterService.getParameter('daliEnvProd');
                console.log('daliEnv', daliEnv);
                this.GTM_CODE = daliEnv
                    ? this.abreCuentasService.getDataTagg().GTM_CODE_PROD
                    : this.abreCuentasService.getDataTagg().GTM_CODE_DEV;
                IS_RELEASE_ENV = daliEnv;
                analyticsJsonURL = abreCuentasConfigs.analytics_json_url;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.daliService
                            .initAnalytics(_this.GTM_CODE, IS_RELEASE_ENV, analyticsJsonURL)
                            .then(function (res) {
                            resolve(res);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    TaggingService.prototype.pageLoadtagg = function (page) {
        var changes = [];
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageName"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageName"].path,
                value: (this.channelCommunicatorService.getChannelId() === '141'
                    ? this.abreCuentasService.getDataTagg().CHANNEL.superapp
                    : this.abreCuentasService.getDataTagg().CHANNEL.homeBanking) + ":" + this.abreCuentasService.getDataTagg().COUNTRY.co + ":" + this.abreCuentasService.getDataTagg().BUSINNESS.pf + ":" + this.abreCuentasService.getDataTagg().ENVIRONMENT.loggeado + ":" + this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageFamily"]
                    .value + ":" + this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "subFamily"]
                    .value + ":" + this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageAction"]
                    .value + ":" + this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageName"]
                    .value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageFamily"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageFamily"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageFamily"]
                    .value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "subFamily"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "subFamily"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "subFamily"]
                    .value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageAction"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageAction"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageAction"]
                    .value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageid"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageid"]
                    .path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "pageid"]
                    .value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionName"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionName"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionName"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionTransactionStep"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionTransactionStep"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "transactionTransactionStep"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "errorname"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "errorname"].path,
                value: this.abreCuentasService.getDataTagg().PAGEVIEW["pv" + page + "errorname"].value,
            });
        }
        this.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    TaggingService.prototype.tagg = function (page, pageEvent, modul, type, position, action) {
        var pagEvent = page ? "pv" + page + "E" + pageEvent : "E" + pageEvent;
        var event = {
            category: {
                module: this.abreCuentasService.getDataTagg().EVENT.customCategory.module[modul],
                type: this.abreCuentasService.getDataTagg().EVENT.customCategory.type[type],
                position: this.abreCuentasService.getDataTagg().EVENT.customCategory.position[position],
            },
            action: this.abreCuentasService.getDataTagg().EVENT.customAction[action],
            label: this.abreCuentasService.getDataTagg().EVENT[page !== ''
                ? "pv" + page + "E" + pageEvent + "customLabel"
                : "E" + pageEvent + "customLabel"],
        };
        var changes = [];
        if (this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionName"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionName"].path,
                value: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionName"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionTransactionStep"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionTransactionStep"].path,
                value: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionTransactionStep"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "clientElegibility"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "clientElegibility"].path,
                value: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "clientElegibility"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().EVENT[pagEvent + "setData"][pagEvent + "transactionProductDetails"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().EVENT[pagEvent + "setData"][pagEvent + "transactionProductDetails"].path,
                value: this.abreCuentasService.getDataTagg().EVENT[pagEvent + "setData"][pagEvent + "transactionProductDetails"].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionProductCategory"]) {
            changes.push({
                path: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionProductCategory"].path,
                value: this.abreCuentasService.getDataTagg().EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + "transactionProductCategory"].value,
            });
        }
        this.pageTagEvent(event, changes);
    };
    /**
     * Función para enviar los datos a Google Analytics
     *
     * *Function to send data to Google Analytics*
     *
     * @param {TagEvent} event
     * @param {Changes[]} changes
     */
    TaggingService.prototype.pageTagEvent = function (event, changes) {
        var newTrackEnventModelinterface = {
            action: event.action,
            category: event.category,
            errorName: event.errorName,
            events: event.events,
            label: event.label,
            messageEvent: event.messageEvent,
            value: event.value,
        };
        console.log('DATAENVIAR-- ', changes);
        console.log('MODELO ', newTrackEnventModelinterface);
        console.log('DATATAGG ', this.abreCuentasService.getDataTagg());
        if (changes) {
            this.daliService.trackEvent(newTrackEnventModelinterface, changes);
        }
        else {
            this.daliService.trackEvent(newTrackEnventModelinterface);
        }
    };
    /**
     * Función para enviar los datos a Google Analytics
     *
     * *Function to send data to Google Analytics*
     *
     * @param {TagEvent} event
     * @param {Changes[]} changes
     */
    TaggingService.prototype.tagEvent = function (eventNumber, category, customAction, error, customTagPageName) {
        var tagPageName = customTagPageName ? customTagPageName : ''; // this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [];
            var transactionName = EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionName"];
            var detailProduct = EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionDetailsProductcategory"];
            var transa = EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionDetailsTransactioninstitution"];
            if (transactionName) {
                changes.push({
                    path: transactionName.path,
                    value: transactionName.value,
                });
            }
            if (detailProduct) {
                changes.push({
                    path: detailProduct.path,
                    value: detailProduct.value,
                });
            }
            if (transa) {
                changes.push({
                    path: transa.path,
                    value: transa.value,
                });
            }
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module[category.module],
                    type: EVENT.customCategory.type[category.type],
                    position: EVENT.customCategory.position[category.position],
                },
                action: EVENT.customAction[customAction],
                label: EVENT[tagPageName + "E" + eventNumber + "customLabel"],
                errorName: error,
            };
            if (changes.length > 0) {
                this.daliService.trackEvent(event_1, changes);
            }
            else {
                this.daliService.trackEvent(event_1);
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * Obtiene el id del tag del producto
     *
     * *Gets tag id by product*
     *
     * @returns {string}
     */
    TaggingService.prototype.getTagIdByProduct = function () {
        var productSelected = this.abreCuentasService.getproductSelected(); // should existe after first page
        switch (productSelected.product_type) {
            case BUSINESS_CONST.PRODUCT_TYPE_TC:
                return this.tagsIdentifiers.tc;
            case BUSINESS_CONST.PRODUCT_TYPE_PAYROLL:
                return this.tagsIdentifiers.payroll;
            case BUSINESS_CONST.PRODUCT_TYPE_SAVINGS:
                return this.tagsIdentifiers.savingAccount;
            case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
                return this.tagsIdentifiers.revolvingCredit;
            default:
                return '';
        }
    };
    /**
     * Establece el id del tag en la variable tagsIdentifier
     *
     * *Sets tag id in tagsIdentifier variable*
     *
     * @param {string} Tc
     * @param {string} payroll
     * @param {string} savingAccount
     * @param {string} revolvingCredit
     */
    TaggingService.prototype.setTagId = function (Tc, payroll, savingAccount, revolvingCredit) {
        this.tagsIdentifiers = new TagIdentifier(Tc, payroll, savingAccount, revolvingCredit);
    };
    TaggingService.prototype.pageTagEventOccupation = function (message, tagPageName) {
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E10setData"][tagPageName + "E10transactionName"].path,
                    value: EVENT[tagPageName + "E10setData"][tagPageName + "E10transactionName"].value,
                },
                {
                    path: EVENT[tagPageName + "E10setData"][tagPageName + "E10transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E10setData"][tagPageName + "E10transactionDetailsProductcategory"].value,
                },
            ];
            var event_2 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.button,
                    position: EVENT.customCategory.position.bottom,
                },
                action: EVENT.customAction.click,
                label: message,
            };
            this.pageTagEvent(event_2, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * Crea el arreglo de cambios para el transactionProductCategory y el transactionName
     * @param tagPageName
     * @param tag_number
     * @returns changes array
     */
    TaggingService.prototype.createTagChanges = function (tagPageName, tag_number) {
        return [
            {
                path: EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionDetailsProductcategory"].path,
                value: EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionDetailsProductcategory"]
                    .value,
            },
            {
                path: EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionName"].path,
                value: EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionName"].value,
            },
        ];
    };
    TaggingService.prototype.addCommonPageChanges = function (changes) {
        var isApp = this.channelCommunicatorService.getChannelId().toString() === '141';
        var developmentTypeValue = isApp ? 'App' : 'Web';
        var siteChannelValue = isApp ? 'SuperAppPF' : 'HomeBankingPF';
        var permissionsValue = isApp
            ? this.abreCuentasService.getDevicePermissions()
            : 'NotAvailable';
        var commonChanges = [];
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.siteChannel) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.siteChannel
                    .path,
                value: siteChannelValue,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.developmenttype) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.developmenttype
                    .path,
                value: developmentTypeValue,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.environment) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.environment.path,
                value: this.parameterService.getParameter('daliEnvProd') ? 'Prod' : 'Dev',
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.useragent) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.useragent.path,
                value: window.navigator.userAgent,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.permissions) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.permissions.path,
                value: permissionsValue,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.accessibility) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.accessibility.path,
                value: 'Off',
            });
        }
        if (PAGEVIEW['siteChannel' + developmentTypeValue]) {
            commonChanges.push({
                path: PAGEVIEW['siteChannel' + developmentTypeValue].path,
                value: PAGEVIEW['siteChannel' + developmentTypeValue].value,
            });
        }
        if (this.abreCuentasService.getDataTagg().PAGEVIEW.clientIdpf) {
            commonChanges.push({
                path: this.abreCuentasService.getDataTagg().PAGEVIEW.clientIdpf.path,
                value: this.bioCatchService.getUserPPID(),
            });
        }
        commonChanges.forEach(function (commonChange) { return changes.push(commonChange); });
    };
    TaggingService.prototype.applyPascalCaseFormat = function (text) {
        var str = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, _index) { return word.toUpperCase(); })
            .replace(/\s+/g, '');
    };
    TaggingService.prototype.sendTaggValues = function (value, page, position, event, extras) {
        if ((this.channelCommunicatorService.getChannelId() === CHANNEL.SUPERAPP.CODE ||
            this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALPN.CODE)
            && this.productsAccepted()) {
            try {
                var transactionName = this.transactionName(page, event);
                switch (value) {
                    case 'init':
                        if (Array.isArray(extras)) {
                            for (var key in extras) {
                                if (extras[key]['pageValue'] == null) {
                                    this.abreCuentasService.setDataTagg('page', extras[key]['object'], page, '', extras[key]['value']);
                                }
                                else {
                                    this.abreCuentasService.setDataTagg('page', 'pageid', page, '', extras[key]['pageValue']);
                                }
                            }
                        }
                        else {
                            this.abreCuentasService.setDataTagg('page', 'pageid', page, '', extras.pageValue);
                        }
                        this.abreCuentasService.setDataTagg('page', 'transactionName', page, '', transactionName);
                        this.pageLoadtagg(page);
                        break;
                    case 'next':
                        if (extras && extras.object !== undefined) {
                            this.abreCuentasService.setDataTagg('event', extras.object, page, event, extras.value);
                        }
                        this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
                        this.tagg(page, event, 'body', 'button', position, 'click');
                        break;
                    case 'header':
                        this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
                        this.tagg(page, event, 'header', 'button', position, 'click');
                        break;
                    default:
                        this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
                        this.tagg(page, event, 'body', 'button', position, 'click');
                }
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    TaggingService.prototype.transactionName = function (page, event) {
        var transactionName = '';
        var product_type = this.abreCuentasService.getproductSelected().product_type;
        var pageEvent = page
            ? (event ? "pv" + page + "E" + event : "pv" + page)
            : "E" + event;
        var dataTaggeo = this.abreCuentasService.getDataTagg().EVENT[pageEvent + "setData"][pageEvent + "transactionName"];
        if (dataTaggeo.value) {
            console.log('TransactionName traído.');
            var complement = this.abreCuentasService.getPostlogin() ? 'E' : 'N';
            transactionName = dataTaggeo.value + "C" + complement;
            console.log('TransactionName: ', transactionName);
        }
        else {
            // tslint:disable-next-line:no-multi-spaces
            if (product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                transactionName = 'OfertaSoloCP';
            }
            if (product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
                transactionName = 'OfertaSoloCR';
            }
            if (product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
                transactionName = 'OfertaSoloTC';
            }
            console.log('TransactionName asignado');
        }
        return transactionName;
    };
    TaggingService.prototype.productsAccepted = function () {
        var product_type = this.abreCuentasService.getproductSelected().product_type;
        if ((product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            product_type == BUSINESS_CONST.PRODUCT_TYPE_TC ||
            product_type === BUSINESS_CONST.MULTI)
            || (product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
                product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)
                && !this.firmlyApprovedService.isFirmlyApproved()) {
            return true;
        }
        return false;
    };
    TaggingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TaggingService_Factory() { return new TaggingService(i0.ɵɵinject(i1.DaliService), i0.ɵɵinject(i2.AbreCuentasService), i0.ɵɵinject(i3.ParametersService), i0.ɵɵinject(i4.ChannelCommunicatorService), i0.ɵɵinject(i5.BioCatchService), i0.ɵɵinject(i6.FirmlyApprovedService)); }, token: TaggingService, providedIn: "root" });
    return TaggingService;
}());
export { TaggingService };
